import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=4411c5ed&scoped=true"
import script from "./Alerts.ts?vue&type=script&lang=ts&external"
export * from "./Alerts.ts?vue&type=script&lang=ts&external"
import style0 from "./Alerts.vue?vue&type=style&index=0&id=4411c5ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411c5ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4411c5ed')) {
      api.createRecord('4411c5ed', component.options)
    } else {
      api.reload('4411c5ed', component.options)
    }
    module.hot.accept("./Alerts.vue?vue&type=template&id=4411c5ed&scoped=true", function () {
      api.rerender('4411c5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/pages/Alerts/Alerts.vue"
export default component.exports